import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";
import { ReactSelectOption } from "../../models/generic/ReactSelectOption";
import { NavListItem, NavigatableRecordItem } from "../../models/adminNav";

export interface NavItemEditData {
    id: number;
    active: boolean;
    locked: boolean;
    onMenu: boolean;
    parentId: ReactSelectOption | NavListItem | null;
    relatedRecordId: ReactSelectOption | NavigatableRecordItem | null;
    title: string;
    typeId: number;
    url: NavItemEditUrl;
}

export interface NavItemEditUrl {
    changeUrl: boolean;
    currentUrl: string;
    newUrl: string;
    updateChildren: boolean;
}

export class NavItemEdit implements FormValidationModel<NavItemEditData> {
    public data: NavItemEditData;
    public rules: yup.Schema<NavItemEditData>;

    public constructor() {
        this.data = {
            id: 0,
            active: true,
            locked: false,
            onMenu: true,
            parentId: null,
            relatedRecordId: { value: 0, label: "", title: "(Placeholder)", typeId: 0 },
            title: "",
            typeId: 0,
            url: {
                changeUrl: false,
                currentUrl: "/",
                newUrl: "",
                updateChildren: false,
            },
        };
        this.rules = yup.object<NavItemEditData>().shape({
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            active: yup.bool(),
            locked: yup.bool(),
            onMenu: yup.bool().label("Show on menu"),
            parentId: ReactSelectOptionSchema.required().label("Parent"),
            relatedRecordId: ReactSelectOptionSchema.required().label("Related page").nullable(true).notOneOf([undefined], "Please select a related page"),
            title: yup.string().required(),
            typeId: yup.number().required().min(0),
            url: yup.object<NavItemEditUrl>().shape({
                changeUrl: yup.bool().label("Change URL"),
                currentUrl: yup.string(),
                newUrl: yup.string().label("New URL").when("changeUrl", {
                    is: true,
                    then: yup.string().required(),
                    otherwise: yup.string().nullable(true),
                }),
                updateChildren: yup.bool().label("Also update child URLs"),
            }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminNav/NavItemEdit.ts